var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "Messenger_svg__c",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAABBklEQVRoge3UIUtDURiA4QcUEcFoMCiGqU38AZYFi2Dwn9hsollBEMwmk81gWLIZDBoFs80igoioM+zKdrfjnQx2Zvge+Mo9X3gv3HsIIYQQQgghhBD+jRrqmO2zN4MzNLAw7Ki/mMQ5msW847h43q2Ox47dg0yNlU60gzrnFovFzhj28dG1s5U7ttsaPqVfoIlnbOMqcdYYQW/JOO78Hl81b1jOn1y2Y7D4JvZG0FsyjxeDxT9I/+BZXegNu8EuXhNnP/OF9RH0lmzojTrCRHG+gnvpFzjNHZtyqB30hM3EzrRWbOcNdYmpTI2VlnCt9RnN9dmtad31q8OOCiGEEEIIIYSQyzeky3RIpfdDQwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Messenger_svg__e",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAA8klEQVRoge3UMStFYRzH8Q9JFjOLMhncTJTByGZSdrGZlBfhFXgBFqO8AouUjdVkM1LSLYqu4XZzznFPl+Uc6vep/3Ke//A99fQQERERERER8S+tYrvtiKI1XOIB51is2ZvAET7QQ6eRuhE66OoHDaaL3creHK4KO/eYai5zuHFcK8cX5wTT2MJj5Wyzhd5v9tXHD+Z9yLezNmKrZvBk9A9Up4v5Fnq/OfX7+B4O24itWleOesEOZvWvR138rf5L1KpJ3ClHLRTOx3CAN+X4Vyw3WlpjyVfUsfqncAUXeMYNNhqp+6E9fywoIiIiIiIimvIJaxBhKyKy+YcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Messenger_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Messenger_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.05,
    d: "M0 0h48v48H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Messenger_svg__f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Messenger_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.07,
    d: "M0 0h48v48H0z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Messenger_svg__b",
    gradientUnits: "userSpaceOnUse",
    cx: 51.759,
    cy: 136.767,
    fx: 51.759,
    fy: 136.767,
    r: 126.251,
    gradientTransform: "scale(.27907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1292ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#2982ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4e69ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#6559ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#6d53ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#df47aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#ff6257"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Messenger_svg__a",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 24C4.8 13.395 13.396 4.8 24 4.8c10.605 0 19.2 8.595 19.2 19.2 0 10.605-8.595 19.2-19.2 19.2-10.605 0-19.2-8.595-19.2-19.2zM24 42.238c10.074 0 18.238-8.164 18.238-18.238S34.074 5.762 24 5.762 5.762 13.926 5.762 24 13.926 42.238 24 42.238zm0 0",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 23.754c0 7.969-6.624 14.43-14.8 14.43-1.223 0-2.406-.145-3.54-.418a1.497 1.497 0 00-1.023.109L16.2 39.492a1.257 1.257 0 01-1.82-1.125v-2.976c0-.426-.188-.825-.504-1.11-2.879-2.636-4.676-6.375-4.676-10.527 0-7.969 6.625-14.43 14.801-14.43s14.8 6.461 14.8 14.43zm0 0",
    fill: "url(#Messenger_svg__b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Messenger_svg__c",
    mask: "url(#Messenger_svg__d)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Messenger_svg__e",
    mask: "url(#Messenger_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.691 20.055l-4.218 3.12a1.242 1.242 0 01-1.508.009l-2.942-2.211a2.664 2.664 0 00-3.84.695l-.894 1.398-3.043 4.942c-.445.695.406 1.488 1.066.992l4.22-3.121a1.242 1.242 0 011.507-.008l2.941 2.211a2.664 2.664 0 003.84-.695l.895-1.399 3.043-4.941c.441-.695-.406-1.488-1.067-.992zm0 0",
    fill: "#fff"
  }))));
}

export default SvgMessenger;